/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2018/8/1 9:22
 */
import withTitle from './withTitle'
import withUserInfo from './withUserInfo'
import withLang from './withLang'
import withShops from './withShops'
import withPrivilegeUse from './withPrivilegeUse'
import withAccountBalance from './withAccountBalance'
import withAuthorization from './withAuthorization'
import withMyAssets from './withMyAssets'
import withPaymentPassword from './withPaymentPassword'

export * from './withTitle'
export * from './withUserInfo'
export * from './withLang'
export * from './withShops'
export * from './withPrivilegeUse'
export * from './withAccountBalance'
export * from './withAuthorization'
export * from './withMyAssets'
export * from './withPaymentPassword'
export {
  withTitle,
  withUserInfo,
  withLang,
  withShops,
  withPrivilegeUse,
  withAccountBalance,
  withMyAssets,
  withAuthorization,
  withPaymentPassword,
}
